import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["inputArea"]

  connect() {
    this.resize();
    this.inputAreaTarget.addEventListener("input", this.resize.bind(this));
  }

  disconnect() {
    this.inputAreaTarget.removeEventListener("input", this.resize.bind(this));
  }

  resize() {
    const inputArea = this.inputAreaTarget;
    inputArea.style.height = "auto";
    inputArea.style.height = inputArea.scrollHeight + "px";
  }
}
